import {useEffect} from "react";

import {geolocationService} from "@/src/modules/core/lib/geolocation-service";

/**
 * Keeps one session-wide geolocation watch + automatic permission recovery.
 *
 * Recovery layers (no manual retry in UI):
 * 1. watchPosition — live position / permission errors
 * 2. Permissions API `change` — site permission toggles (desktop + Android)
 * 3. focus / pageshow / visibility — return from Settings or another app
 * 4. blocked recovery interval — platform-tuned polling while denied (iOS 4s, Android 6s, desktop 12s)
 */
export function GeolocationProvider({children}: {children: React.ReactNode}) {
  useEffect(() => {
    geolocationService.startSession();
    return () => {
      geolocationService.stopSession();
    };
  }, []);

  return children;
}
